module.exports = __webpack_public_path__ + "img/iphone-aoty-2018_jp.fd972fb.svg";